import { Select } from "antd";
import { Controller, useFormContext } from "react-hook-form";

const DropdownField = ({ top = false, label, htmlfor, required = false, onChange = (e) => {}, ...rest }) => {
  const { formState: { errors }, watch } = useFormContext();
  const get = (obj, path) => {
    if (!path) return undefined;
    return path.split('.').reduce((o, k) => (o ? o[k] : undefined), obj);
  };
  const fieldError = get(errors, htmlfor);
  const value = watch?.(htmlfor);
  const hasValue = value !== undefined && value !== null && value !== '';
  const showRequired = !!required && !hasValue;

  return (
    <div
      className={`sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start py-5 ${
        top ? "pt-0" : "sm:border-t"
      } sm:border-gray-200`}
    >
      <label
        htmlFor={`${label}`}
        className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
      >
        {label}{showRequired && <span className="text-red-500 ml-1">*</span>}
      </label>
      <div className="mt-1 sm:mt-0 sm:col-span-2">
        <BasicDropdownField
          {...rest}
          htmlfor={htmlfor}
          required={required}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

export const BasicDropdownField = ({
  htmlfor,
  required,
  onChange = (e) => {},
  ...rest
}) => (
  <Controller
    name={htmlfor}
    rules={{required}}
    render={({field}) => (
      <Select
        {...rest}
        {...field}
        size='large'
        optionFilterProp='label'
        className='w-full sm:max-w-xs'
        onChange={(e) => {
          onChange(e)
          field.onChange(e)
        }}
      />
    )}
  />
)


export default DropdownField;
